import { useRef, useEffect } from 'react';
import { escape, unescape } from 'lodash';
import {Editor} from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor.css';

// color plugin
import 'tui-color-picker/dist/tui-color-picker.css';
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css';
import colorSyntax from '@toast-ui/editor-plugin-color-syntax';

const ToastEditor = props => {
  const {content, setContent} = props
  const editorRef = useRef(null)

  useEffect(() => {    
    if(content) {
      try {
        editorRef.current?.getInstance().setHTML(unescape(content));
      } catch(e) {
        console.error(e);
      }
    }
  }, [content]);

  const handleChange = () => {
    const data = editorRef.current?.getInstance().getHTML();
    setContent(escape(data))
  }

  return (
    <Editor
      ref={editorRef}
      placeholder="내용을 입력해주세요."
      previewStyle="vertical"
      height="400px"
      initialEditType="wysiwyg"
      // hideModeSwitch={true}
      onBlur={handleChange}
      plugins={[colorSyntax]}
    />
  )
}

export default ToastEditor